import Video from '@cartwhl/ui/atoms/Video';
import Text from '@cartwhl/ui/base/TextNew';

import { useAssetLibraryCompactLayout } from '../assetLibraryEmbedContext';
import type { AssetLibraryViewMode } from '../assetLibraryGridLayout';
import type { MotionLibraryDisplayItem } from '../assetLibraryMotionLibrary';
import { isAssetVideoThumbnail } from '../utils';
import { getAssetLibraryCardLayoutClasses } from './AssetLibraryCardShell';
import AssetLibraryCardShell from './AssetLibraryCardShell';

const THUMBNAIL_FRAME_CLASS =
  'bg-tertiary relative h-full w-full overflow-hidden rounded-lg';

/** Motion library previews are rendered 1:1, unlike 16:9 asset thumbnails. */
const GRID_THUMBNAIL_CLASS = 'aspect-square w-full';

/** Matches the height of the 120px-wide 16:9 asset thumbnails in list rows. */
const LIST_THUMBNAIL_CLASS = 'aspect-square w-[68px]';

export interface AssetLibraryMotionCardProps {
  motion: MotionLibraryDisplayItem;
  layout?: AssetLibraryViewMode;
  onClick?: () => void;
}

export default function AssetLibraryMotionCard({
  motion,
  layout = 'grid',
  onClick,
}: AssetLibraryMotionCardProps) {
  const compact = useAssetLibraryCompactLayout();
  const { titleToken } = getAssetLibraryCardLayoutClasses(compact);
  const isVideo = isAssetVideoThumbnail('MOGEN_JOB', motion.previewURL);
  const isInteractive = Boolean(onClick);
  const isListLayout = layout === 'list';

  return (
    <AssetLibraryCardShell
      compact={compact}
      layout={layout}
      interactive={isInteractive}
      onClick={onClick}
    >
      <div
        className={`relative shrink-0 ${
          isListLayout ? LIST_THUMBNAIL_CLASS : GRID_THUMBNAIL_CLASS
        }`}
      >
        <div className={THUMBNAIL_FRAME_CLASS}>
          {!motion.previewURL ? null : isVideo ? (
            <Video
              src={motion.previewURL}
              className="absolute inset-0 h-full w-full"
              mode="autoplay"
              crossOrigin="anonymous"
            />
          ) : (
            <img
              src={motion.previewURL}
              alt=""
              className="absolute inset-0 h-full w-full object-cover object-center"
              crossOrigin="anonymous"
            />
          )}
        </div>
      </div>
      <div className="flex min-w-0 flex-col gap-1 px-2">
        <Text
          token={titleToken}
          className="text-secondary truncate"
          title={motion.title}
        >
          {motion.title}
        </Text>
        <Text
          token={compact ? { base: '12', sm: '14' } : '14'}
          className="text-tertiary truncate"
        >
          Motion library
        </Text>
      </div>
    </AssetLibraryCardShell>
  );
}
